// ICMS completo e ST/FCP-ST na tela (F0c/F0d). Espelho de
// backend/app/services/icms_completo.py — só para MOSTRAR os valores e o total
// da nota; quem calcula o XML é o backend. Os percentuais vêm do cadastro do
// produto (só o escritório altera).

export const CAMPOS_FISCAIS_PRODUTO = [
  'reducao_bc_icms', 'diferimento_icms', 'aliquota_fcp', 'modalidade_bc_st', 'mva_st',
  'reducao_bc_st', 'aliquota_icms_st', 'aliquota_fcp_st', 'motivo_desoneracao',
  'deduz_desoneracao',
];

export const MODALIDADES_BC_ST = [
  { codigo: '4', descricao: 'Margem de valor agregado (MVA)' },
  { codigo: '6', descricao: 'Valor da operação' },
];

const CST_NOVOS = ['10', '20', '30', '51', '70', '90'];
const CSOSN_ST = ['201', '202', '203'];
const CST_ST_OBRIGATORIA = ['10', '30', '70'];
const ST_OPCIONAL = ['90', '900'];
export const CST_COM_REDUCAO = ['20', '51', '70', '90'];
export const CST_COM_DIFERIMENTO = ['51', '90'];
export const CST_COM_FCP = ['00', '10', '20', '70', '90'];
export const MOTIVOS_DESONERACAO = {
  '20': ['3', '9', '10', '11', '12'], '30': ['6', '7', '9'],
  '40': ['1', '3', '4', '5', '6', '7', '8', '9', '10', '11', '16', '90'],
  '41': ['1', '3', '4', '5', '6', '7', '8', '9', '10', '11', '16', '90'],
  '50': ['1', '3', '4', '5', '6', '7', '8', '9', '10', '11', '16', '90'],
  '70': ['3', '9', '12'], '90': ['3', '9', '12'],
};

const usaCsosn = regime => [1, 4].includes(Number(regime));
const n = v => {
  const x = Number(String(v ?? '').replace(',', '.'));
  return Number.isFinite(x) ? x : 0;
};
const q2 = v => Math.round((v + Number.EPSILON) * 100) / 100;
const t = v => String(v ?? '').trim();

export function temSt(item) {
  return !!t(item?.modalidade_bc_st)
    || ['mva_st', 'reducao_bc_st', 'aliquota_icms_st', 'aliquota_fcp_st'].some(c => n(item?.[c]) > 0);
}

// O código tem ST obrigatória / admite ST?
export function codigoComSt(regime, cst) {
  const c = t(cst);
  return usaCsosn(regime) ? (CSOSN_ST.includes(c) || c === '900') : (CST_ST_OBRIGATORIA.includes(c) || c === '90');
}

// O item depende dos dados fiscais do cadastro do produto (o backend confere).
export function precisaDadosFiscais(regime, item) {
  const c = t(item?.cst_icms);
  const novo = usaCsosn(regime) ? CSOSN_ST.includes(c) : CST_NOVOS.includes(c);
  return novo || temSt(item) || !!t(item?.motivo_desoneracao)
    || ['reducao_bc_icms', 'diferimento_icms', 'aliquota_fcp'].some(k => n(item?.[k]) !== 0);
}

// Copia do produto para o item (seleção do produto na emissão). null = não informado.
export function dadosFiscaisDoProduto(prod) {
  const out = {};
  CAMPOS_FISCAIS_PRODUTO.forEach(c => { out[c] = prod?.[c] ?? null; });
  return out;
}

// IPI do item (F0f; RIPI art. 190: vProd + frete + seguro + outras, sem o desconto incondicional —
// STF, Tema 84, RE 567.935), só para empresa contribuinte do IPI e CST tributado (50, 99, 00, 49).
export function calcularIpiItem(item, contribuinteIpi) {
  if (!contribuinteIpi || !['50', '99', '00', '49'].includes(t(item?.cst_ipi))) return 0;
  const vprod = q2(n(item?.quantidade) * n(item?.valor_unitario));
  const base = vprod - n(item?.valor_desconto) + n(item?.valor_frete) + n(item?.valor_seguro) + n(item?.valor_outros);
  return q2(q2(base) * n(item?.aliquota_ipi) / 100);
}

// Contas do item (mesmas do backend). modFrete 0 = CIF (frete na base própria).
export function calcularIcmsItem(regime, item, modFrete = 9, vipi = 0) {
  const cst = t(item?.cst_icms);
  const simples = usaCsosn(regime);
  const vprod = q2(n(item?.quantidade) * n(item?.valor_unitario));
  const desc = n(item?.valor_desconto), frete = n(item?.valor_frete);
  const seg = n(item?.valor_seguro), outros = n(item?.valor_outros);
  const bp = vprod - desc + seg + outros + (Number(modFrete) === 0 ? frete : 0);
  const aliq = n(item?.aliquota_icms), red = n(item?.reducao_bc_icms), dif = n(item?.diferimento_icms);
  const r = { vbc: 0, vicms: 0, vfcp: 0, vbcst: 0, vst: 0, vfcpst: 0, deson: 0, deduz: false };
  const proprio = !simples && (['10', '20', '51', '70'].includes(cst) || (cst === '90' && aliq > 0));
  if (proprio) {
    r.vbc = q2(red ? bp * (100 - red) / 100 : bp);
    if (cst === '51' || (cst === '90' && dif > 0)) {
      const op = q2(r.vbc * aliq / 100);
      r.vicms = q2(op - q2(op * dif / 100));
    } else {
      r.vicms = q2(r.vbc * aliq / 100);
    }
    if (n(item?.aliquota_fcp) > 0) r.vfcp = q2(r.vbc * n(item.aliquota_fcp) / 100);
  } else if (!simples && cst === '00') {
    r.vbc = q2(bp); r.vicms = q2(r.vbc * aliq / 100);
    if (n(item?.aliquota_fcp) > 0) r.vfcp = q2(r.vbc * n(item.aliquota_fcp) / 100);
  } else if (simples && cst === '900') {
    r.vbc = q2(bp); r.vicms = q2(r.vbc * aliq / 100);
  }
  const stObrig = simples ? CSOSN_ST.includes(cst) : CST_ST_OBRIGATORIA.includes(cst);
  if (stObrig || (ST_OPCIONAL.includes(cst) && temSt(item))) {
    let base = vprod + frete + seg + outros + vipi - desc;
    if (t(item?.modalidade_bc_st) === '4') base = base * (100 + n(item?.mva_st)) / 100;
    if (n(item?.reducao_bc_st)) base = base * (100 - n(item.reducao_bc_st)) / 100;
    r.vbcst = q2(base);
    const deducao = simples ? (cst === '900' ? r.vicms : q2(bp * aliq / 100)) : r.vicms;
    r.vst = q2(q2(r.vbcst * n(item?.aliquota_icms_st) / 100) - deducao);
    if (n(item?.aliquota_fcp_st) > 0) r.vfcpst = q2(q2(r.vbcst * n(item.aliquota_fcp_st) / 100) - r.vfcp);
  }
  if (t(item?.motivo_desoneracao) || n(item?.valor_icms_desonerado) > 0) {
    r.deson = q2(n(item?.valor_icms_desonerado));
    r.deduz = t(item?.deduz_desoneracao) === '1';
  }
  return r;
}

// O que ST/FCP-ST, IPI, IPI devolvido e a desoneração somam ou tiram do total (W16-10).
// A prévia do ICMS próprio não soma o IPI na base (consumidor final): só a ST usa o IPI.
export function ajusteTotalNota(regime, itens, modFrete = 9, contribuinteIpi = false) {
  return q2((itens || []).reduce((s, it) => {
    const vipi = calcularIpiItem(it, contribuinteIpi);
    const c = calcularIcmsItem(regime, it, modFrete, vipi);
    return s + c.vst + c.vfcpst - (c.deduz ? c.deson : 0) + vipi + n(it?.valor_ipi_devolvido);
  }, 0));
}
